import React from 'react';
import type { Doc } from '../../../../backend/convex/_generated/dataModel';
import { useWorkspaces } from '../hooks/useWorkspaces';

interface WorkspaceSwitcherProps {
  selectedWorkspaceId: string | null;
  onSelect: (workspaceId: string | null) => void;
}

export const WorkspaceSwitcher: React.FC<WorkspaceSwitcherProps> = ({ 
  selectedWorkspaceId, 
  onSelect 
}) => {
  const { workspaces, isLoading } = useWorkspaces();

  if (isLoading) return <div style={{ fontSize: '0.8rem', color: 'var(--muted-foreground)' }}>Loading workspaces...</div>;
  if (workspaces.length <= 1) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <select 
        value={selectedWorkspaceId || ''} 
        onChange={(e) => onSelect(e.target.value)}
        style={{
          padding: '0.35rem 0.75rem',
          borderRadius: '6px',
          border: '1px solid var(--border)',
          background: 'var(--secondary)',
          color: 'var(--foreground)',
          fontSize: '0.85rem',
          minWidth: '160px',
          cursor: 'pointer'
        }}
      >
        {workspaces.map((w: Doc<"workspaces"> & { role: string }) => (
          <option key={w._id} value={w._id}>
            {w.name} {w.slug === 'default' ? '(Default)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

